import Button, { ButtonLevel } from "components/ui/Button";
import IconList, { IconListItem } from "components/ui/IconList";
import { LinkButton } from "components/ui/Link";
import React from "react";
import { getUsersProfile } from "store/api/apiSlice";
import { ApiUsersProduct } from "utils/api/users";
import { getPartnerConfig } from "utils/partner";
import Layout from "../Layout";
import { SlideProps } from "./types";

const EWA_FLEX_ITEMS: IconListItem[] = [
  {
    icon: "split",
    title: "One card, multiple ways to pay",
    body: "Flexibly spend from your checking account or earnings with the debit card you already have.",
  },
  {
    icon: "dollarChart",
    title: "Switchboard",
    body: "Automatically switch between checking and earnings with intelligent transaction routing.",
  },
  {
    icon: "lightbulbDollar",
    title: "Make the most of your paycheck",
    body: <>Access your income daily as you earn it&mdash;no&nbsp;fees.</>,
  },
];

const getEwaDirectItems = (partnerName?: string): IconListItem[] => {
  return [
    {
      icon: "lightbulbDollar",
      title: "Make the most of your paycheck",
      body: <>Access your income daily as you earn it&mdash;no&nbsp;fees.</>,
    },
    {
      icon: "pieChart",
      title: "Budgeting on autopilot",
      body: (
        <>
          We factor in your expenses to create a spending limit
          tailored&nbsp;to&nbsp;you.
        </>
      ),
    },
    {
      icon: "handshake",
      title: partnerName
        ? `Free for ${partnerName} members`
        : "Free for members",
      body: (
        <>
          No interest and no monthly or late fees. It's your money,
          just&nbsp;sooner.
        </>
      ),
    },
  ];
};

const getItems = ({
  product,
  partnerName,
}: {
  product?: ApiUsersProduct;
  partnerName?: string;
}) => {
  if (product === ApiUsersProduct.ewaDirect)
    return getEwaDirectItems(partnerName);

  return EWA_FLEX_ITEMS;
};

const Overview: React.FC<SlideProps> = ({ onCancel, embedded, onContinue }) => {
  const { data: userProfile } = getUsersProfile();
  const partner = getPartnerConfig();

  const items = getItems({
    product: userProfile?.product,
    partnerName: partner?.name,
  });

  return (
    <Layout
      heading={
        <>
          Access your paycheck&mdash;<em>today.</em>
        </>
      }
      subheading="Account setup takes minutes. We'll automatically verify your income, employment and direct deposit."
      actions={
        <>
          {embedded && <LinkButton onClick={onCancel}>No, thanks</LinkButton>}

          <Button level={ButtonLevel.cta} fullWidth onClick={onContinue}>
            Continue
          </Button>
        </>
      }
    >
      <IconList items={items} isLarge />
    </Layout>
  );
};

export default Overview;
